import { render } from "./ExpensePage.vue?vue&type=template&id=ec7d8952&scoped=true"
import script from "./ExpensePage.vue?vue&type=script&lang=js"
export * from "./ExpensePage.vue?vue&type=script&lang=js"

import "./ExpensePage.vue?vue&type=style&index=0&id=ec7d8952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7d8952"]])

export default __exports__